import axios from "axios";
import { API } from "@/lib/api";

const REF_KEY = "rv_ref";
const VISITOR_KEY = "rv_visitor_id";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

export const getVisitorId = () => {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
};

// Active first-touch promoter ID (null once the 30-day window lapses).
export const getActiveRef = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(REF_KEY) || "null");
    if (raw && raw.id && raw.expires > Date.now()) return raw.id;
    if (raw) localStorage.removeItem(REF_KEY);
  } catch {
    localStorage.removeItem(REF_KEY);
  }
  return null;
};

// First-touch: a ?ref= only sticks if no promoter already holds this visitor and it's approved.
export const captureRef = async (search) => {
  const ref = (new URLSearchParams(search).get("ref") || "").trim().toLowerCase();
  if (!ref || getActiveRef()) return;
  try {
    const { data } = await axios.get(`${API}/ref/validate/${encodeURIComponent(ref)}`);
    if (!data.valid) return;
    localStorage.setItem(REF_KEY, JSON.stringify({ id: ref, expires: Date.now() + TTL_MS }));
    document.cookie = `${REF_KEY}=${ref}; max-age=${TTL_MS / 1000}; path=/; SameSite=Lax`;
  } catch {
    /* tracking must never break browsing */
  }
};

export const trackRefVisit = (path) => {
  const ref = getActiveRef();
  if (!ref) return;
  axios.post(`${API}/ref/visit`, { promoter_id: ref, visitor_id: getVisitorId(), path }).catch(() => {});
};
